// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `tr.Review {
  background-color: #fae9af;
}
tr.Decline {
  background-color: #ec6f6f;
}
`, "",{"version":3,"sources":["webpack://./src/app/screening-module/components/decision-grid-eviction-settings-read/decision-grid-eviction-settings-read.component.less"],"names":[],"mappings":"AACI;EACI,yBAAA;AAAR;AAEI;EACI,yBAAA;AAAR","sourcesContent":["tr{\n    &.Review{\n        background-color: #fae9af;\n    }\n    &.Decline{\n        background-color: #ec6f6f\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
